import { render } from "./LoyaltyPreferenceChoices.vue?vue&type=template&id=ee263874&scoped=true"
import script from "./LoyaltyPreferenceChoices.vue?vue&type=script&lang=js"
export * from "./LoyaltyPreferenceChoices.vue?vue&type=script&lang=js"

import "./LoyaltyPreferenceChoices.vue?vue&type=style&index=0&id=ee263874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee263874"]])

export default __exports__